import { STAT_DEFS } from "../types/profile";

const getTotalValue = (
  totalTimePlayed: number,
  totalPlayedGames?: number,
  xp?: number,
) => {
  return [
    {
      key: "playedGames" as const,
      label: STAT_DEFS.playedGames.label,
      icon: STAT_DEFS.playedGames.icon,
      value: totalPlayedGames ?? 0,
      showGem: false,
    },
    {
      key: "totalTime" as const,
      label: STAT_DEFS.totalTime.label,
      icon: STAT_DEFS.totalTime.icon,
      value: Number((totalTimePlayed / 3600).toFixed(1)),
      showGem: false,
    },
    {
      key: "totalGems" as const,
      label: STAT_DEFS.totalGems.label,
      icon: STAT_DEFS.totalGems.icon,
      value: xp,
      showGem: true,
    },
  ];
};

export const ProfileMd = {
  getTotalValue,
};
